<template>
  <mds-combo-box
    :label="parameter.label"
    :data-set="parameterOptions"
    :selected-items="option"
    @input="onChangeValue"
  />
</template>

<script>
import MdsComboBox from '@mds/combo-box'
import isArray from 'lodash/isArray'

export default {
  name: 'SimpleOptionsComboBox',
  components: {
    MdsComboBox,
  },
  props: {
    parameter: {
      type: Object,
      default: /* istanbul ignore next */ () => ({}),
    },
    editedFeed: {
      type: Object,
      default: () => undefined,
    },
  },
  data() {
    return {
      option: [],
    }
  },
  created() {
    // Set the option to the saved value or the first element from the dropdown.
    this.option = this.savedOption ? this.savedOption : this.preselectedItem

    this.$emit('input', { [this.parameterName]: this.option[0] })
  },
  computed: {
    parameterName() {
      const { name } = this.parameter
      return name
    },
    savedOption() {
      // If the edited feed was initially an Investment List and then changed to a PR,
      // let's search by the ID to determine if the values match.
      const selectedOption = this.parameterOptions.find(
        (option) => option.value === this.editedFeed?.[this.parameterName]
      )

      return selectedOption ? [selectedOption.value] : undefined
    },
    parameterOptions() {
      if (this.parameter && isArray(this.parameter.options)) {
        return this.parameter.options.map((option) => ({
          value: option.id,
          text: option.name,
        }))
      }
      return []
    },
    preselectedItem() {
      if (isArray(this.parameter.options)) {
        return [this.parameterOptions[0].value]
      }
      return []
    },
  },
  methods: {
    onChangeValue(e) {
      this.option = e
      this.$emit('input', { [this.parameterName]: this.option[0] })
    },
  },
}
</script>
